import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { FETCH_ARCHIVE_SOLD } from '../../../redux/ArchiveTables';
import Table from '../../Table/Table';
import { tablesHeaders } from '../../../consts/tablesConf';
import { SOLD } from '../../../consts/navigation';
import { vehicleTypes } from '../../../consts/vehicleTypes';

class ArchiveSoldContainer extends PureComponent {
  static whichFolder = SOLD;

  render() {
    const {
      fetchItems,
      totalCount,
      totalPages,
      data,
      renderRow,
      handleShowOffer,
      vehicleType,
    } = this.props;
    const { whichFolder } = ArchiveSoldContainer;
    return (
      <Table
        whichFolder={whichFolder}
        tableHeaders={tablesHeaders[vehicleType][whichFolder]}
        fetchOffers={fetchItems}
        totalCount={totalCount}
        totalPages={totalPages}
        renderRow={renderRow}
        onRowClick={handleShowOffer}
        items={data}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: get(state, ['archive', SOLD, 'data']),
    totalCount: get(state, ['archive', SOLD, 'total_count']),
    totalPages: get(state, ['archive', SOLD, 'total_pages']),
    vehicleType: get(state, ['vehicleType', 'vehicleType'])
  };
};

const mapDispatchToProps = (dispatch) => {
  return { fetchItems: () => dispatch(FETCH_ARCHIVE_SOLD()) };
};

ArchiveSoldContainer.propTypes = {
  fetchItems: PropTypes.func.isRequired,
  vehicleType: PropTypes.oneOf(Object.keys(vehicleTypes)).isRequired,
  renderRow: PropTypes.func.isRequired,
  handleShowOffer: PropTypes.func.isRequired,
  totalCount: PropTypes.number,
  totalPages: PropTypes.number,
};

ArchiveSoldContainer.defaultProps = {
  data: [],
  totalCount: 0,
  totalPages: 1,
};

export default connect(mapStateToProps, mapDispatchToProps)(ArchiveSoldContainer);
